(function ($, ko) {

    ko.bindingHandlers.chartPlanDates = {
        init: function (element, valueAccessor) {
            let chartParams = ko.unwrap(valueAccessor());
            let fieldsAliases = chartParams.account.FieldsAliases;
            let account = chartParams.details;
            // Added for Deadline chart
            if (!account || !account.AccountId) return;

            var planStartDate = moment(account.PlanStartDate);            
            var planEndDate = moment(account.PlanEndDate);
            var lastDayForSpending = moment(account.LastDayForSpending);
            var lastDayToSubmitClaims = moment(account.LastDayToSubmitClaim);
            var now = moment();
            // NOTE: change dates here to test charts
            // var now = moment('2013-12-31T06:00:00');

            var displayStartDate = !account.ShowEligibilityDate;
            //Array with dates
            var sortedDatesArr = [
                { date: planStartDate, type: 'planStartDate', hidden: !fieldsAliases.PlanStartDate, color: displayStartDate ? $.cdh.brandData.ChartDeadlinesPlanStartDate : $.cdh.brandData.ChartDeadlinesPlanPeriod, labelId: 'account-balance_item-planStartDate'},
                { date: planEndDate, type: 'planEndDate', hidden: !fieldsAliases.PlanEndDate, color: $.cdh.brandData.ChartDeadlinesYourEndDate, labelId: 'account-balance_item-planEndDate' },
                { date: lastDayForSpending, type: 'lastDayForSpending', hidden: !fieldsAliases.LastDayForSpending, color: $.cdh.brandData.ChartDeadlinesLastDayForSpending, labelId: 'account-balance_item-lastDayForSpending' },
                { date: lastDayToSubmitClaims, type: 'lastDayToSubmitClaims', hidden: !fieldsAliases.LastDayToSubmitClaims, color: $.cdh.brandData.ChartDeadlinesLastDayToSubmitClaims, labelId: 'account-balance_item-lastDayToSubmitClaims' },
                { date: now, type: 'now', color: $.cdh.brandData.ChartDeadlinesTodaySeparator, isToday: true }
            ];

            
            if (account.ShowEligibilityDate) {
                var eligibilityDate = moment(account.EligibilityDate);
                sortedDatesArr.push({ date: eligibilityDate, type: 'eligibilityDate', color: '#383838', labelId: 'account-balance_item-eligibilityDate' });
            }

            //Sort array by date
            sortedDatesArr.sort(function (a, b) {
                return new Date(a.date.toDate()) - new Date(b.date.toDate());
            });
            
            let firstDateElement = $('#' + sortedDatesArr.find(x => !x.hidden && !!x.labelId).labelId);
            
            //Replace color scheme to corresponding colors
            $.extend(true, $.jqx._jqxChart.prototype.colorSchemes, [
                {
                    name: 'accountsSchemePlanDatesSorted',
                    colors: [sortedDatesArr[0].color, $.cdh.brandData.ChartDeadlinesPlanPeriod, sortedDatesArr[1].color, $.cdh.brandData.ChartDeadlinesPlanRunOutGracePeriod, sortedDatesArr[2].color, $.cdh.brandData.ChartDeadlinesPlanRunOutGracePeriod, sortedDatesArr[3].color, $.cdh.brandData.ChartDeadlinesPlanRunOutGracePeriod, sortedDatesArr[4].color]
                }
            ]);
            if (sortedDatesArr.length === 6) {
                $.jqx._jqxChart.prototype.colorSchemes[0].colors[3] =  $.cdh.brandData.ChartDeadlinesPlanPeriod;
                $.jqx._jqxChart.prototype.colorSchemes[0].colors.push($.cdh.brandData.ChartDeadlinesPlanRunOutGracePeriod);
                $.jqx._jqxChart.prototype.colorSchemes[0].colors.push(sortedDatesArr[5].color);
            }
            
            var chartSeparatorWidth = 6;
            var chartWidth = $(element).width();
            var spacingWidth = chartWidth - chartSeparatorWidth * sortedDatesArr.length;
            var maxDatesDiff = sortedDatesArr[0].date.diff(sortedDatesArr[sortedDatesArr.length-1].date, 'days');
            
            let seriesDefaultItems = sortedDatesArr
                .slice(0, 4)
                .flatMap((x, index) => [
                    { dataField: `value${index*2 + 1}`, dateType: x.type, displayText: '', labels: { visible: false }, showToolTips: false },
                    { dataField: `value${index*2 + 2}`, displayText: '', labels: { visible: false }, showToolTips: false }]);

            let dataArrObj = sortedDatesArr
                .slice(0, 5)
                .flatMap((x, index) => {
                    if(x.hidden) {
                        return [0, 0];
                    } else {
                        let result = [chartSeparatorWidth];
                        let nextVisibleItem = sortedDatesArr.find((item, i) => i > index && !item.hidden);
                        if(nextVisibleItem) {
                            result.push(Math.round(x.date.diff(nextVisibleItem.date, 'days') * spacingWidth / maxDatesDiff));
                        } 
                        return result;
                    }
                })
                .reduce((result, x, index) => {
                    result['value' + (index + 1)] = x;
                    return result;
                }, {});
            
            //horizontal column chart rendering
            var chartData = {
                element: element,
                colorScheme: 'accountsSchemePlanDatesSorted',
                padding: { left: 0, top: 0, right: 0, bottom: 0 },
                valueAxis: { visible: false },
                seriesGroups: [{
                    type: 'stackedcolumn100',
                    columnsMaxWidth: 45,
                    columnsMinWidth: 45,
                    orientation: 'horizontal',
                    useGradientColors: false,
                    xAxis: { visible: false },
                    valueAxis:
                    {
                        visible: false,
                        flip: true,
                        displayValueAxis: false,
                        description: '',
                        axisSize: 'auto',
                        tickMarksColor: '#888888'
                    },
                    series: seriesDefaultItems
                }],
                dataArr: [dataArrObj]
            };
            
            if (account.ShowEligibilityDate) {
                chartData.seriesGroups[0].series.push({ dataField: 'value9', dateType: sortedDatesArr[4].type, displayText: '', labels: { visible: false }, showToolTips: false });
                chartData.seriesGroups[0].series.push({ dataField: 'value10', displayText: '', labels: { visible: false }, showToolTips: false });
                chartData.seriesGroups[0].series.push({dataField: 'value11', dateType: sortedDatesArr[sortedDatesArr.length - 1].type,
                    // displayText: sortedDatesArr[sortedDatesArr.length - 1].date.format('MMM D, YYYY'),
                    // labels: { visible: true, offset: { x: 0, y: 40 }, verticalAlignment: 'left', class: 'account-contribution-text' },
                    // formatFunction: function (value, itemIndex, serie, group) { return sortedDatesArr[sortedDatesArr.length - 1].date.format('MMM D, YYYY'); },
                    displayText: '',
                    labels: { visible: false },
                    showToolTips: false
                });

                let visibleDataArr = sortedDatesArr.filter((x, index) => !x.hidden && index < 5);
                let lastOfVisibleDataArr = visibleDataArr[visibleDataArr.length - 1];
                $.extend(true, chartData.dataArr[0],
                {
                    value10: Math.round(lastOfVisibleDataArr.date.diff(sortedDatesArr[5].date, 'days') * spacingWidth / maxDatesDiff),
                    value11: chartSeparatorWidth
                });

            } else {
                chartData.seriesGroups[0].series.push({
                    dataField: 'value9', dateType: sortedDatesArr[sortedDatesArr.length - 1].type,
                    // displayText: sortedDatesArr[sortedDatesArr.length - 1].date.format('MMM D, YYYY'),
                    // labels: { visible: true, offset: { x: 0, y: 40 }, verticalAlignment: 'left', class: 'account-contribution-text' },
                    // formatFunction: function (value, itemIndex, serie, group) { return sortedDatesArr[sortedDatesArr.length - 1].date.format('MMM D, YYYY'); },
                    displayText: '',
                    labels: {visible: false},
                    showToolTips: false
                });
            }


            //create the chart
            $.cdh.charts.bindStackedColumnChart(chartData, function() {
                setTimeout(function () {

                    // // add today tooltip
                    // var todayRectNumber = 0;
                    // var todayRects = {
                    //     0: 2,
                    //     1: 4,
                    //     2: 6,
                    //     3: 8,
                    //     4: 10
                    // };
                    // for (var i = 0, len = sortedDatesArr.length; i < len; i++) {
                    //     if ('isToday' in sortedDatesArr[i] && sortedDatesArr[i].isToday === true) {
                    //         todayRectNumber = todayRects[i] - 2;
                    //     }
                    // }
                    // var $g = $(element).find('g:last');
                    // var $r = $g.find('rect:eq(' + todayRectNumber + ')');
                    // var oy = parseFloat($r.attr('y'));
                    // var ox = parseFloat($r.attr('x'));
                    // var ow = parseFloat($r.attr('width'));
                    // var offsetY = 16;

                    // var tooltip = $('<div/>', {
                    //     'class': 'chart-tooltip'
                    // }).appendTo($(element));
                    // tooltip.html('<p><b>' + now.format('MMM D, YYYY') + '</b></p>' +
                    //                 '<p>TODAY</p>' +
                    //                 '<div class="chart-tooltip-angle-box">' +
                    //                 '<div class="chart-tooltip-angle"></div>' +
                    //                 '<div class="chart-tooltip-border-angle"></div>' +
                    //                 '<div class="chart-tooltip-shadow-angle"></div>' +
                    //                 '</div>');
                    // var angle = $(element).find('div.chart-tooltip-angle-box');
                    // var parentBoxWidth = $(element).outerWidth();
                    // var tooltipWidth = tooltip.outerWidth();
                    // var tooltipHeight = tooltip.outerHeight();
                    // var tooltipLeft = ox;
                    // var tooltipMarginLeft = (-(tooltipWidth / 2) + ow / 2);
                    // var tooltipTriangleMargin = 8; // 8 is margin to not move triangle from tooltip if current date is at start or end
                    // if ((tooltipLeft + tooltipMarginLeft) < 0) {
                    //     tooltipLeft = -tooltipMarginLeft - tooltipTriangleMargin;
                    //     angle.css({
                    //         'left': (ox + ow / 2 + tooltipTriangleMargin) + 'px'
                    //     });
                    // } else if ((tooltipLeft + tooltipWidth + tooltipMarginLeft) > parentBoxWidth) {
                    //     tooltipLeft = parentBoxWidth - tooltipWidth - tooltipMarginLeft + tooltipTriangleMargin;
                    //     angle.css({
                    //         'left': ((ox + ow / 2) - (parentBoxWidth - tooltipWidth) - tooltipTriangleMargin) + 'px'
                    //     });
                    // }
                    // /* add static width/height for tooltip to prevent block dimensions changes and fix css padding problem */
                    // tooltip.css({
                    //     'width': tooltipWidth + 'px',
                    //     'height': tooltipHeight + 'px',
                    //     'left': tooltipLeft + 'px',
                    //     'top': (oy - tooltip.outerHeight() - offsetY) + 'px',
                    //     'margin-left': tooltipMarginLeft + 'px',
                    //     'padding': '1px',
                    // });

                    //let IntervalType = chartParams.account.accountIntervalType();
                    //if (!account || !account.AccountId || IntervalType) return;

                    // reset elements top offset
                    var labelsWrapper = $('div.account-balance_column-timeline');
                    $(element).css({
                        marginTop: 0
                    });
                    labelsWrapper.css({
                        top: 0
                    });


                    // set lines height
                    var $g = $(element).find('g:last');
                    var series = chartData.seriesGroups[0].series;
                    var offsetLine = 10;
                    var offsetText = 60;
                    var offsetTextMargin = 10;
                    var offsetNum = 1;
                    var labelOffsetX = 5;
                    var labelOffsetY = 0;
                    // var chartMarginTop = parseInt($(element).css('margin-top').replace('px', ''), 10);
                    var chartMarginTop = 0;
                    var rectsToMove = [];
                    var chartContainer = $g.closest('div.chartContainer');
                    var chartContainerWidth = chartContainer.outerWidth();
                    var chartContainerWrapper = chartContainer.closest('div.account-balance_chart-timeline-wrapper');
                    var taLeftClassName = 'account-balance_item__ta-left';
                    var rectPlanStartDate = null;
                    var lowLabelsData = [];
                    var firstLowElementDefined = false;


                    // get rect by index
                    function getRectByIndex(index) {
                        if (!('dateType' in series[index]) || series[index].dateType === '') {
                            return null;
                        }

                        var rect = {};
                        rect.elem = $g.find('rect:eq(' + index + ')');
                        rect.width = parseFloat(rect.elem.attr('width'));
                        rect.height = parseFloat(rect.elem.attr('height'));
                        rect.x = parseFloat(rect.elem.attr('x'));
                        rect.y = parseFloat(rect.elem.attr('y'));
                        rect.type = series[index].dateType;
                        return rect;
                    } // get rect by index


                    // get prev rect by index
                    function getPrevRectByIndex(index) {
                        for (var i = (index - 1); i >= 0; i--) {
                            if ('dateType' in series[i] && series[i].dateType !== '') {
                                return getRectByIndex(i);
                            }
                        }

                        return null;
                    } // get prev rect by index


                    // get label elem coords
                    function getLabelElemCoords(labelElem, rect) {
                        var labelElemWidth = labelElem.outerWidth();

                        var result = {
                            labelElemWidth: labelElemWidth,
                            placedToLeft: {},
                            placedToRight: {}
                        };

                        result.placedToLeft.left = rect.x - labelElemWidth - labelOffsetX;
                        result.placedToLeft.right = result.placedToLeft.left + labelElemWidth;

                        result.placedToRight.left = rect.x + rect.width + labelOffsetX;
                        result.placedToRight.right = result.placedToRight.left + labelElemWidth;

                        return result;
                    } // get label elem coords


                    // series loop
                    for (var i = 0, len = series.length; i < len; i++) {
                        var serie = series[i];
                        var rect = getRectByIndex(i);
                        if (rect === null) {
                            continue;
                        }

                        var rectHeightNew = rect.height;
                        var rectYNew = rect.y;
                        var type = serie.dateType;
                        var labelElem = $('#account-balance_item-' + type);
                        var rectMovedIndex = 0;


                        // set line height and top. set labels coords.

                        // first date
                        if (type === 'planStartDate') {
                            rectPlanStartDate = rect;
                            rectYNew = rect.y - offsetText - offsetLine;
                            rect.elem.attr('y', rectYNew);
                            rect.elem.attr('height', rect.height + offsetText + offsetLine * 2);
                            labelElem.css({
                                left: rect.x + chartSeparatorWidth + labelOffsetX,
                                top: rectYNew + labelOffsetY + chartMarginTop
                            });
                            rectMovedIndex = 290;

                        // last date
                        } else if (type === 'lastDayToSubmitClaims') {
                            rectYNew = rect.y - offsetText - offsetLine;
                            var rectHeight = rect.height + offsetText + offsetLine * 2;
                            rect.elem.attr('y', rectYNew);
                            rect.elem.attr('height', rectHeight);
                            
                            // set position for last date
                            if(firstDateElement.length > 0) {
                                var firstDateWidth = firstDateElement.outerWidth();
                                var firstDatePos = firstDateElement.position();
                                var firstDateRight = firstDatePos.left + firstDateWidth;
                            }

                            var lastDayToSubmitClaimsCoords = getLabelElemCoords(labelElem, rect);

                            // place label to left
                            var lastDayToSubmitClaimsLeft = lastDayToSubmitClaimsCoords.placedToLeft.left;
                            var lastDayToSubmitClaimsTop = rectYNew + labelOffsetY + chartMarginTop;

                            // rect covers prev label
                            if (rect.x < firstDateRight + labelOffsetX * 2) {

                                if(firstDateElement.length > 0) {
                                    // move first label higher
                                    firstDateElement.css({
                                        top: firstDatePos.top - offsetText
                                    });
                                }
                                if(rectPlanStartDate) {
                                    rectPlanStartDate.elem.attr('y', parseInt(rectPlanStartDate.elem.attr('y'), 10) - offsetText);
                                    rectPlanStartDate.elem.attr('height', parseInt(rectPlanStartDate.elem.attr('height'), 10) + offsetText);
                                }

                                // place label to right
                                lastDayToSubmitClaimsLeft = lastDayToSubmitClaimsCoords.placedToRight.left;
                                labelElem.addClass(taLeftClassName);

                            // rect doesn't cover prev label
                            } else {

                                // label covers prev label
                                if (lastDayToSubmitClaimsCoords.placedToLeft.left < firstDateRight + labelOffsetX * 2) {

                                    // label fits to chart from right side
                                    if (lastDayToSubmitClaimsCoords.placedToRight.right < chartContainerWidth) {

                                        // place label to right
                                        lastDayToSubmitClaimsLeft = lastDayToSubmitClaimsCoords.placedToRight.left;
                                        labelElem.addClass(taLeftClassName);

                                    // label doesn't fit to chart from right side
                                    } else {

                                        // move label higher (and leave label placed to left)
                                        lastDayToSubmitClaimsTop = lastDayToSubmitClaimsTop - offsetText;
                                        rect.elem.attr('y', rectYNew - offsetText);
                                        rect.elem.attr('height', rectHeight + offsetText);
                                    }
                                }
                            }

                            labelElem.css({
                                left: lastDayToSubmitClaimsLeft,
                                top: lastDayToSubmitClaimsTop
                            });
                            rectMovedIndex = 300;

                        // middle dates
                        } else {

                            var labelElemLeft = 0;
                            var labelElemCoords = getLabelElemCoords(labelElem, rect);

                            var lowLabelData = {
                                label: {
                                    elem: labelElem,
                                    left: 0,
                                    width: labelElem.outerWidth(),
                                    placedToLeft: true
                                },
                                rect: rect,
                                level: 1
                            };


                            // first low element
                            if (!firstLowElementDefined) {

                                // label doesn't fit to chart from left side
                                if (labelElemCoords.placedToLeft.left < 0) {

                                    // place label to right
                                    labelElemLeft = labelElemCoords.placedToRight.left;
                                    lowLabelData.label.placedToLeft = false;

                                // label fits to chart from left side
                                } else {

                                    // place label to left
                                    labelElemLeft = labelElemCoords.placedToLeft.left;
                                    lowLabelData.label.placedToLeft = true;
                                }

                                // set label left coord
                                lowLabelData.label.left = labelElemLeft;

                                // set first low element as defined
                                firstLowElementDefined = true;

                            // other low elements
                            } else {
                                var prevLabelData = lowLabelsData[lowLabelsData.length - 1];

                                // prev label placed to left
                                if (prevLabelData.label.placedToLeft) {

                                    // NOTE: first algorithm (use only one version of the algorithm)

                                    // // place label to left
                                    // lowLabelData.label.left = labelElemCoords.placedToLeft.left;
                                    // lowLabelData.label.placedToLeft = true;

                                    // // label covers prev rect 
                                    // if (lowLabelData.label.left < prevLabelData.rect.x + prevLabelData.rect.width + labelOffsetX * 2) {

                                    //     // set label level
                                    //     lowLabelData.level = prevLabelData.level + 1;
                                    // }
                                    // / NOTE: first algorithm


                                    // NOTE: second algorithm (use only one version of the algorithm)

                                    // label doesn't cover prev rect
                                    if (labelElemCoords.placedToLeft.left > prevLabelData.rect.x + prevLabelData.rect.width + labelOffsetX * 2) {

                                        // place label to left
                                        lowLabelData.label.left = labelElemCoords.placedToLeft.left;
                                        lowLabelData.label.placedToLeft = true;

                                    // label covers prev rect
                                    } else {

                                        // label fits to chart from right side
                                        if (labelElemCoords.placedToRight.right < chartContainerWidth) {

                                            // place label to right
                                            lowLabelData.label.left = labelElemCoords.placedToRight.left;
                                            lowLabelData.label.placedToLeft = false;

                                        // label doesn't fit to chart from right side
                                        } else {

                                            // place label to left
                                            lowLabelData.label.left = labelElemCoords.placedToLeft.left;
                                            lowLabelData.label.placedToLeft = true;

                                            // set label level
                                            lowLabelData.level = prevLabelData.level + 1;
                                        }
                                    }
                                    // / NOTE: second algorithm

                                // prev label placed to right
                                } else {

                                    // label doesn't cover prev label
                                    if (labelElemCoords.placedToLeft.left > prevLabelData.label.left + prevLabelData.label.width + labelOffsetX * 2) {

                                        // place label to left
                                        lowLabelData.label.left = labelElemCoords.placedToLeft.left;
                                        lowLabelData.label.placedToLeft = true;

                                    // label covers prev label
                                    } else {

                                        // label fits to chart from right side
                                        if (labelElemCoords.placedToRight.right < chartContainerWidth) {

                                            // place label to right
                                            lowLabelData.label.left = labelElemCoords.placedToRight.left;
                                            lowLabelData.label.placedToLeft = false;

                                            // set level for prev labels placed to right
                                            for (var j = lowLabelsData.length - 1; j >= 0; j--) {
                                                if (!lowLabelsData[j].label.placedToLeft) {
                                                    lowLabelsData[j].level += 1;
                                                } else {
                                                    break;
                                                }
                                            }

                                        // label doesn't fit to chart from right side
                                        } else {

                                            // place label to left
                                            lowLabelData.label.left = labelElemCoords.placedToLeft.left;
                                            lowLabelData.label.placedToLeft = true;

                                            // move label lower
                                            lowLabelData.level = prevLabelData.level + 1;

                                            // check if label doesn't cover prev label with same level
                                            for (var j = lowLabelsData.length - 1; j >= 0; j--) {
                                                if (lowLabelsData[j].level === lowLabelData.level) {

                                                    // prev label placed to right
                                                    if (!lowLabelsData[j].label.placedToLeft) {

                                                        // label covers prev label
                                                        if (lowLabelsData[j].label.left + lowLabelsData[j].label.width + labelOffsetX * 2 > lowLabelData.label.left) {
                                                            lowLabelData.level += 1;
                                                        }

                                                    // prev label placed to left
                                                    } else {

                                                        // label covers prev rect
                                                        if (lowLabelsData[j].rect.x + lowLabelsData[j].rect.width + labelOffsetX * 2 > lowLabelData.label.left) {
                                                            lowLabelData.level += 1;
                                                        }
                                                    }
                                                }
                                            }

                                        }
                                    }
                                }

                            } // other low elements

                            lowLabelsData.push(lowLabelData);

                            if (type === 'lastDayToSubmitClaims') {
                                rectMovedIndex = 200;
                            } else {
                                rectMovedIndex = 10 * offsetNum;
                            }

                            offsetNum += 1;

                        } // middle dates

                        rectsToMove.push({
                            elem: rect.elem,
                            index: rectMovedIndex
                        });

                    } // series loop

                    // move line rects to the end (rects between lines can overlap them)
                    rectsToMove.sort(function (a, b) {
                        return a.index - b.index;
                    }).reverse();

                    for (var i = 0, len = rectsToMove.length; i < len; i++) {
                        rectsToMove[i].elem.appendTo($g);
                    }


                    // draw middle rects and labels
                    var lowLabelRectY = rect.y - offsetLine;
                    var lowLabelRectBaseHeight = rect.height + offsetLine + offsetTextMargin;
                    
                    let topLabelPositions = sortedDatesArr
                        .filter(x => !x.hidden && !!x.labelId)
                        .map(x => $('#' + x.labelId).position().top)
                        .filter(x => x > 0);
                    let minLabelTop = topLabelPositions.length > 0 ? Math.min(...topLabelPositions) : chartContainerWrapper.outerHeight() / 3;

                    var maxLabelBottom = 0;
                    for (var i = 0, len = lowLabelsData.length; i < len; i++) {
                        var lowLabelRectHeight = lowLabelRectBaseHeight + offsetText * lowLabelsData[i].level;
                        lowLabelsData[i].rect.elem.attr('y', lowLabelRectY);
                        lowLabelsData[i].rect.elem.attr('height', lowLabelRectHeight);

                        // set label styles
                        lowLabelsData[i].label.elem.css({
                            left: lowLabelsData[i].label.left,
                            top: lowLabelRectY + lowLabelRectHeight - labelElem.outerHeight() - labelOffsetY + chartMarginTop
                        });

                        maxLabelBottom = Math.max(maxLabelBottom, lowLabelRectY + lowLabelRectHeight);

                        if (lowLabelsData[i].label.placedToLeft) {
                            lowLabelsData[i].label.elem.removeClass(taLeftClassName);
                        } else {
                            lowLabelsData[i].label.elem.addClass(taLeftClassName);
                        }
                    }

                    // set chart height
                    var chartContainerWrapperHeight = (maxLabelBottom - minLabelTop) + chartMarginTop + offsetTextMargin;
                    chartContainerWrapper.outerHeight(chartContainerWrapperHeight);
                    $(element).css({
                        marginTop: '-180' + 'px'
                    });
                    labelsWrapper.css({
                        top: '-180' + 'px'
                    });

                }, 1000);
            });
        }
    };

    ko.bindingHandlers.chartDeadlinePlanStartDate = {
        update: function (element) {
           $(element).css('background', $.cdh.brandData.ChartDeadlinesPlanStartDate);
        }
    };
    
    ko.bindingHandlers.chartDeadlinesYourEndDate = {
        update: function (element) {
            $(element).css('background', $.cdh.brandData.ChartDeadlinesYourEndDate);
        }
    };
    
    ko.bindingHandlers.chartDeadlinesLastDayForSpending = {
        update: function (element) {
            $(element).css('background', $.cdh.brandData.ChartDeadlinesLastDayForSpending);
        }
    };
    
    ko.bindingHandlers.chartDeadlinesLastDayToSubmitClaims = {
        update: function (element) {
            $(element).css('background', $.cdh.brandData.ChartDeadlinesLastDayToSubmitClaims);
        }
    }

})(jQuery, ko);

